// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import About from './pages/About';
import Register from './pages/Register';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Profile from './pages/Profile';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import PaymentSuccess from './pages/PaymentSuccess';
import Invoice from './pages/Invoice';
import InstallmentPay from './pages/InstallmentPay';
import ProfileOrders from './pages/ProfileOrders';
import Affordable from './pages/Affordable';
import { useBarcodeScanner } from './hooks/useBarcodeScanner';

// کامپوننت جدید: فقط برای اجرای listener داخل روتر
function AppContent() {
  useBarcodeScanner(); // ← اینجا کاملاً امن است (داخل <Router> قرار دارد)

  useEffect(() => {
    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
      let updateRegistration = null;

      import('./serviceWorkerRegistration').then(({ register }) => {
        register({
          onUpdate: (registration) => {
            updateRegistration = registration;
            toast(
              <div dir="rtl" className="flex flex-col items-center gap-4 p-4">
                <strong className="text-lg">نسخه جدید موجود است!</strong>
                <button
                  onClick={() => {
                    if (updateRegistration?.waiting) {
                      updateRegistration.waiting.postMessage({ type: 'SKIP_WAITING' });
                    }
                    window.location.reload();
                  }}
                  className="px-8 py-3 bg-green-600 hover:bg-green-700 rounded-xl font-semibold transition"
                >
                  بروزرسانی کن
                </button>
              </div>,
              {
                duration: Infinity,
                position: 'top-center',
                style: { background: '#1f2937', color: '#fff', borderRadius: '16px' },
              }
            );
          },
        });
      });
    }
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Toaster />
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/register" element={<Register />} />
          <Route path="/products" element={<Products />} />
          <Route path="/product/:barcode" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/invoice/:orderId" element={<Invoice />} />
          <Route path="/installmentPay" element={<InstallmentPay />} />
          <Route path="/profile/orders" element={<ProfileOrders />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/affordable" element={<Affordable />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;